import React from 'react';
import AboutData from './AboutData';
import MarketingData from './MarketingData';
import Supplemental from '../../../../Quoters/Supplemental/Supplemental';
import PurchasingProcessData from './PurchasingProcessData';

export default function SuppData(props) {
  const minAge = 18;
  const maxAge = 64;

  return {
    name: 'Supplemental Insurance',
    subtitle: 'Make the Unexpected Easier',
    footerMessage: "Apply for Supplemental Insurance",
    specs: {
      age: { min: minAge, max: maxAge },
    },
    basicInfoForm: (history) => {
      return <Supplemental landing history={history} ref={props.aboutMeFormRef} />;
    },
    about: AboutData(),
    marketing: MarketingData(props.handleSubmitClick),
    purchasingProcess: PurchasingProcessData(),
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Supplemental/SuppData.js